import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'
import {
    baseUrl
} from '@/config/env';


export const mobileRedPacketDetailOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: false,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "红包名称",
            prop: "redPacketName",
            span:13,
            type: 'input',
        },
        {
            label: "红包类型",
            prop: "payment",
            type: 'select',
            span:13,
            placeholder:'请选择红包类型',
            // valueDefault:"JOINS_ENGINEER",
            dicData:DIC.PAYMENT,
            addVisdiplay: false,
            editVisdiplay: false,
        }, 
      
        {
            label: "领取人",
            prop: "realName",
            search:true,
            span:13,
            type: 'input',
        },
        {
            label: "领取金额",
            prop: "quota",
            span:13,
            type: 'input',
        },
        {
            label: "状态",
            prop: "status",
            type: 'select',
            span:13,
            search:true,
            placeholder:'请选择红包类型',
            // valueDefault:"JOINS_ENGINEER",
            dicData:DIC.REDPACKET_TYPE,
            addVisdiplay: false,
            editVisdiplay: false,
        }, 
        {
            label: "领取时间",
            prop: "collectionTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        // {
        //     label: "更新人",
        //     prop: "createBy",
        //     type: "input",
        //     hide:true,
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     width: "110"
        // },
    ]
};